import api from './api';
import { LoginRequest, RegisterRequest, Token, UserResponse } from '../types';

export const authService = {
  getGoogleAuthUrl: async (): Promise<string> => {
    // Same hardened guard as services/api.ts — strips real AND literal "\n".
    const RAW = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
    const API_BASE_URL = RAW
      .replace(/(\\[rn])+$/g, '')
      .replace(/[\r\n\t\s]+$/g, '')
      .replace(/^\s+/g, '');
    try {
      const response = await fetch(`${API_BASE_URL}/auth/google/login`);
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const errorMessage = errorData.detail || 'Failed to get Google auth URL';
        const error = new Error(errorMessage);
        (error as any).response = { status: response.status, data: errorData };
        throw error;
      }
      const data = await response.json();
      return data.auth_url;
    } catch (err: any) {
      // Re-throw with response info if available
      if (err.response) {
        throw err;
      }
      throw new Error('Google OAuth yapılandırılmamış veya bağlantı hatası');
    }
  },
  async login(username: string, password: string): Promise<Token> {
    try {
      console.log('Attempting login for:', username);
      console.log('API Base URL:', process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1');
      
      // Create a timeout promise for login (30 seconds)
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Login timeout - Backend yanıt vermiyor'));
        }, 30000); // 30 second timeout for login
      });
      
      // Race between login and timeout
      const response = await Promise.race([
        api.post<Token>('/auth/login', { username, password }),
        timeoutPromise
      ]) as any;
      
      console.log('Login response status:', response.status);
      console.log('Login response data:', response.data);
      
      if (response.data.access_token) {
        localStorage.setItem('access_token', response.data.access_token);
        console.log('Token saved to localStorage');
      } else {
        console.warn('No access_token in response:', response.data);
      }
      return response.data;
    } catch (error: any) {
      console.error('Login API error:', error);
      console.error('Error code:', error?.code);
      console.error('Error message:', error?.message);
      console.error('Error response:', error?.response?.data);
      console.error('Error status:', error?.response?.status);
      console.error('Error config:', error?.config?.url);
      throw error;
    }
  },

  async register(data: RegisterRequest): Promise<UserResponse> {
    const response = await api.post<UserResponse>('/auth/register', data);
    return response.data;
  },

  async getCurrentUser(): Promise<UserResponse> {
    try {
      console.log('Getting current user...');
      const response = await api.get<UserResponse>('/auth/me');
      console.log('Current user response:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('getCurrentUser error:', error);
      console.error('Error response:', error?.response?.data);
      console.error('Error status:', error?.response?.status);
      throw error;
    }
  },

  async refreshToken(): Promise<Token> {
    const response = await api.post<Token>('/auth/refresh');
    if (response.data.access_token) {
      localStorage.setItem('access_token', response.data.access_token);
    }
    return response.data;
  },

  logout(): void {
    localStorage.removeItem('access_token');
    window.location.href = '/login';
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('access_token');
  },
};

